export default [
    {
        path: 'sell',
        name: 'sell',
        meta: {
            title: '出售',
            header1: true,
            hasBottom: true
        },
        component: () => import('./Sell')
    },
    {
        path: 'sell/goods',
        name: 'sell.goods',
        meta: {
            title: '出售',
            unPullRefresh: true,
        },
        component: () => import('./SellGoods')
    },
    // 正在出售
    {
        path: 'onsell',
        name: 'onsell',
        meta: {
            title: '出售',
            unPullRefresh: true,
        },
        component: () => import('./OnSell')
    },
    //上架成功
    {
        path:'sell/success',
        name: 'sell.success',
        meta: {
            title: '出售',
        },
        component: () => import('./SellSuccess')
    },
    {
        path: 'market',
        name: 'market',
        meta: {
            title: '交易市场',
            noheader: true,
            unPullRefresh: true,
            white:true,
            keepAlive: true
        },
        component: () => import('./Market')
    }
]